var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYAxis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 0.666992L0.666992 2.66699H2.00033V3.33366H3.33366V2.66699H4.66699L2.66699 0.666992ZM2.00033 4.66699V6.00033H3.33366V4.66699H2.00033ZM2.00033 7.33366V8.66699H3.33366V7.33366H2.00033ZM2.00033 10.0003V11.3337H3.33366V10.0003H2.00033ZM13.3337 11.3337V12.667H3.82194C3.70489 12.4643 3.53654 12.2959 3.3338 12.1789C3.13106 12.0619 2.90108 12.0003 2.66699 12.0003C2.31337 12.0003 1.97423 12.1408 1.72418 12.3909C1.47413 12.6409 1.33366 12.98 1.33366 13.3337C1.33366 13.6873 1.47413 14.0264 1.72418 14.2765C1.97423 14.5265 2.31337 14.667 2.66699 14.667C2.90064 14.6666 3.13008 14.6048 3.33232 14.4878C3.53457 14.3708 3.70251 14.2027 3.81934 14.0003H13.3337V15.3337L15.3337 13.3337L13.3337 11.3337Z",
    fill: "#5C5F62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYAxis);
export default __webpack_public_path__ + "static/media/y-axis.b16530814bf80ff9c06ab538c086d1eb.svg";
export { ForwardRef as ReactComponent };